import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Spin, Typography, Descriptions, Row, Col } from 'antd';

import { CustomButton } from '../../../components';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import {
  get as getCTM,
  getNewInfo,
} from '../../../api/module/mass_contract_modifications';
import { catchException } from '../../../utils/helpers/helpers';
import ModulesHome from './ModulesHome';
import MassContractSearch from './MassContractSearch';
import MESSAGES from '../../../enums/Messages';
import { post } from '../../../api/module/mass_contract_modifications';
import ContractorsModal from './ContractorsModal';

const { Title } = Typography;

const ContractMassModificationsForm = ({ match, sendPerm }) => {
  const breadcrumbItems = [
    {
      text: 'Módulo Modificaciones Contractuales',
      to: `${INTERNAL_LINKS.CONTRACT_MODIFICATIONS}`,
    },
    {
      text: 'Formulario de Modificaciones Contractuales',
    },
  ];
  const [project_id] = useState(parseInt(match.params.proyecto));
  const [ct_mod_id] = useState(match.params.ctm);

  const navigate = useHistory();

  const [initialValues, setInitialValues] = useState(undefined);
  const [startValues, setStartValues] = useState(undefined);

  useEffect(() => {
    async function fetchData() {
      try {
        if (project_id && !ct_mod_id) {
          const { data } = await getNewInfo(project_id);
          setStartValues(data);
        } else {
          const { data } = await getCTM(ct_mod_id);
          setInitialValues(data);
        }
      } catch (error) {
        catchException(error);
      }
    }
    fetchData();
  }, []);

  const next = async (records) => {
    try {
      const res = await post(records);
      navigate.push(
        `${INTERNAL_LINKS.CONTRACT_MASS_MODIFICATIONS}/${project_id}/${res.data.id}`,
      );
    } catch (error) {
      let massIDErr = false;
      if (
        error?.response?.data?.errors &&
        error.response.data.errors[0]?.detail ===
          'El identificador masivo ya existe.'
      )
        massIDErr = true;
      catchException(error, MESSAGES.DESC_ERROR_POST_MSG);
      error.isMassIDErr = massIDErr;
      throw error;
    }
  };

  return (
    <div>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        MÓDULO MODIFICACIONES CONTRACTUALES
      </Title>
      {startValues || initialValues ? (
        <>
          {!initialValues ? (
            <>
              <Title level={3}>PROYECTO: {startValues?.project_name}</Title>
              <MassContractSearch
                project_id={project_id}
                positions={startValues.positions}
                next={next}
              />
            </>
          ) : (
            <>
              <Descriptions
                layout="horizontal"
                column={1}
                bordered
                styles={{
                  label: { maxWidth: '8rem' },
                }}
                className="fade-in"
              >
                <Descriptions.Item label="Proyecto">
                  {initialValues.project_name}
                </Descriptions.Item>
                <Descriptions.Item label="Cargo / Rol">
                  <Row align="middle">
                    <Col flex="auto">{initialValues.cargo_nombre}</Col>
                    <Col flex="0 0">
                      <ContractorsModal initialValues={initialValues} />
                    </Col>
                  </Row>
                </Descriptions.Item>
                <Descriptions.Item label="Identificador interno de la modificación masiva">
                  {initialValues.identificador_masivo}
                </Descriptions.Item>
              </Descriptions>
              <ModulesHome
                project_id={project_id}
                initialValues={initialValues}
                setInitialValues={setInitialValues}
                sendPerm={sendPerm}
              />
            </>
          )}
        </>
      ) : (
        <Spin spinning={true} style={{ width: '100%' }}></Spin>
      )}
      <br />
      <CustomButton
        type={'default'}
        className={'back-button'}
        htmlType="button"
        text={
          <Link to={`${INTERNAL_LINKS.CONTRACT_MODIFICATIONS}`}>Volver</Link>
        }
      />
    </div>
  );
};

export default ContractMassModificationsForm;
